import {useLocation, Navigate} from 'react-router-dom'
import { useContext } from "react";
import { AuthContext } from "../context/authContext";


 



const RequireAuth = ({children}: {children: React.ReactElement}) => {
    const location = useLocation()
    const {currentUser, checkLocalUser}:any = useContext(AuthContext); 
    checkLocalUser();
    if(!currentUser) return <Navigate to="/login" state={{from: location}}/>

    return children
}


export default RequireAuth